import React, { useState } from "react";
import { CiCircleInfo } from "react-icons/ci";

const initialQuestions = [
  {
    id: 1,
    question: "What type of therapy are you looking for?",
    options: ["Individual (for myself)", "Teen", "Child"],
    inputType: "radio",
    scores: [0, 0, 0], // Example scoring for options
  },
];

const childQuestions = [
  {
    id: 2,
    question: "What is your child’s age?",
    options: ["Below 5 years", "5", "6", "7", "8", "9", "10", "11", "12"],
    inputType: "select",
    scores: [0, 0, 0, 0, 0, 0, 0, 0, 0], // Example scoring for options
  },
  {
    id: 3,
    question: "Has your child attended therapy before?",
    options: ["Yes", "No"],
    inputType: "radio",
    scores: [1, 0],
  },
  {
    id: 4,
    question:
      "Had problems sleeping—that is, trouble falling asleep, staying asleep, or waking up too early?",
    options: [
      "None Not at all",
      "Slight Rare, less than a day or two",
      "Mild Several days",
      "Moderate More than half the days",
      "Severe Nearly every day",
    ],
    inputType: "radio",
    scores: [1, 1, 1, 0, 0],
  },
  {
    id: 5,
    question:
      "Said he/she was worried about his/her health or about getting sick?",
    options: [
      "None Not at all",
      "Slight Rare, less than a day or two",
      "Mild Several days",
      "Moderate More than half the days",
      "Severe Nearly every day",
    ],
    inputType: "radio",
    scores: [1, 1, 1, 0, 0],
  },
  {
    id: 6,
    question: "Seemed angry or lost his/her temper?",
    options: [
      "None Not at all",
      "Slight Rare, less than a day or two",
      "Mild Several days",
      "Moderate More than half the days",
      "Severe Nearly every day",
    ],
    inputType: "radio",
    scores: [1, 1, 1, 0, 0],
  },
  {
    id: 7,
    question: "Seemed sad or depressed for several hours?",
    options: [
      "None Not at all",
      "Slight Rare, less than a day or two",
      "Mild Several days",
      "Moderate More than half the days",
      "Severe Nearly every day",
    ],
    inputType: "radio",
    scores: [1, 1, 1, 0, 0],
  },
  // Add scores for other questions...
];

const teenQuestions = [
  {
    id: 2,
    question: "What is your age?",
    options: ["13", "14", "15", "16", "17", "18", "19"],
    inputType: "select",
    scores: [1, 1, 1, 1, 1, 1, 1],
     
  },
  {
    id: 3,
    question: "Which country are you in?",
    options: [
      "India",
      "Indonesia",
      "Australia",
      "Afganistan",
      "Algeria",
      "Bermuda",
      "Zimbabwe",
    ],
    inputType: "select",
    scores: [1, 1, 1, 1, 1, 1, 1],
  },
  {
    id: 4,
    question: "What is your gender identity?",
    options: ["Woman", "Man", "Non Binary", "others"],
    inputType: "radio",
    scores: [1, 1, 1, 0]
  },
  {
    id: 5,
    question: "What is your relationship status?",
    options: ["Single", "In a relationship", "Married", "Divorced"],
    inputType: "radio",
    scores: [1, 1, 1, 0]
  },


];

const RoughQuestions = () => {
  const [qno, setQno] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0); // Track the total score
  const [questions, setQuestions] = useState(initialQuestions);
  const [showScorecard, setShowScorecard] = useState(false);
  const question = questions[qno];

  const handleSelect = (option, index) => {
    setSelected(option);

    // Update score based on selected option
    const optionScore = question.scores[index] || 0;
    setScore((prevScore) => prevScore + optionScore);

    if (qno === 0 && option.includes("Child")) {
      setQuestions(initialQuestions.concat(childQuestions));
    } else if (option.includes("Teen")) {
      setQuestions(initialQuestions.concat(teenQuestions));
    }
  };

  const handleNext = () => {
    if (qno < questions.length - 1) {
      setQno(qno + 1);
      setSelected(null);
    } else {
      // End of questions, show scorecard
      setShowScorecard(true);
    }
  };

  const handleBack = () => {
    if (qno > 0) {
      setQno(qno - 1);
      setSelected(null);
    }
  };

  return (
    <div className=" bg-secondary">
      {showScorecard ? (
        <div className="flex justify-center items-center h-screen">
          <div className="w-96 bg-white p-6 shadow-md rounded-md mt-5 text-center border-2">
          <h2 className="text-2xl font-bold text-accent mb-4">
            Assessment Complete
          </h2>
          <p className="text-lg font-medium mr-5">
            Your total score is:  
            <span
    className={`${
      score <= 3
        ? "text-red-500"
        : score <= 5
        ? "text-orange-500"
        : "text-green-500"
    } font-bold text-2xl` }
  > {score}</span>
          </p>
          <p className="text-sm mt-2 text-gray-500">
            Thank you for completing the assessment. We’ll use your responses
            to find the perfect therapist for you.
          </p>
        </div>
        </div>

      ) : (
        <div className="flex flex-col  items-center pt-10 pb-40">
          <h2 className="mt-8 text-3xl text-white font-serif">
            Allow us to find the right therapist to{" "}
            <span className="text-primary">support your journey</span>
          </h2>
          <h2 className=" text-white/80 text-xs text-center mt-5">
            Finding the right therapist is essential for building a personal
            connection that supports your mental health journey. The following
            questions <br /> are tailored to understand your unique needs and
            preferences, helping you connect with a licensed therapist who is the
            best fit for you.
          </h2>
          <div className="px-8 py-6 w-[400px] my-14 bg-white border shadow-md rounded-md">
            <div className="flex flex-col">
              <div className="font-normal text-base mb-2">{question.question}</div>
              {question.inputType === "select" && (
                <select
                  value={selected}
                  onChange={(e) =>
                    handleSelect(e.target.value, question.options.indexOf(e.target.value))
                  }
                  className="p-2 border rounded-md mt-2"
                >
                  <option value="">Select an option</option>
                  {question.options.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
              {question.inputType === "radio" &&
                question.options.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => handleSelect(option, index)}
                    className={`px-4 py-3 mt-2 mr-2 rounded-full text-left font-normal text-xs ${
                      selected === option
                        ? "bg-primary text-white"
                        : "bg-accent/40 text-black"
                    } hover:bg-primary hover:text-white`}
                  >
                    {option}
                  </button>
                ))}
                {question.inputType === "checkbox" &&
              question.options.map((option, index) => (
                <label
                  key={index}
                  className="flex items-center mt-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    value={option}
                    // checked={selected.includes(option)}
                    onChange={() => handleSelect(option,index)}
                    className="mr-2"
                  />
                  {option}
                </label>
              ))}
              <div className="flex items-center justify-end mt-4 gap-3">
                {qno > 0 && (
                  <button
                    onClick={handleBack}
                    className="px-5 py-2 bg-primary hover:bg-accent text-white rounded-full"
                  >
                    Back
                  </button>
                )}
                <button
                  onClick={handleNext}
                  disabled={!selected}
                  className={`px-5 py-2 ${
                    selected
                      ? "bg-accent/40 hover:bg-accent hover:text-white"
                      : "bg-gray-300"
                  } rounded-full`}
                >
                  {qno < questions.length - 1 ? "Next" : "Finish"}
                </button>
              </div>
            </div>
                      {qno > 0 && (
                        <div className="bg-cyan-100 mt-5 rounded p-3 flex items-start ">
                        <div>
                          {" "}
                          <CiCircleInfo className="h-10 w-6 mr-3 stroke-1 text-cyan-400" />
                        </div>
                        <p className="text-xs text-primaraytext">
                          These questions help match you with a licensed therapist who
                          fits your needs and preferences.
                        </p>
                      </div>
                      )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RoughQuestions;
